<template>
    <div id="Ideacion">
        <header class="cont-tit">
            <h2 class="tit">Ideación</h2>
        </header>
        <div class="wrapper">
            <FormulateForm class="filterbar" @submit="submitHandler" #default="{ isLoading }">
                <div class="form-group">
                    <div class="form-group">
                        <FormulateInput
                                type="text"
                                name="patron"
                                label="Patrón"
                                label-class="control-label"
                                placeholder="Patrón"
                                v-model="patron"
                        />
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-group">
                        <FormulateInput
                                type="select"
                                name="anio"
                                label="Año"
                                label-class="control-label"
                                placeholder="Seleccione"
                                :options="optionsTipoAnio"
                                v-model="anio"
                        />
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-group">
                        <FormulateInput
                                type="select"
                                name="funcs"
                                label="Función"
                                label-class="control-label"
                                placeholder="Seleccione"
                                :options="optionsFunciones"
                                v-model="funciones"
                        />
                    </div>
                </div>
                <FormulateInput
                        type="submit"
                        :disabled="isLoading"
                        :label="isLoading ? 'Cargando...' : 'BUSCAR'"
                        class="formulate-input"
                        v-b-modal.modal-xl-ideacion
                />

            </FormulateForm>

            <!-- <div class="accordion" role="tablist" id="accordion1">
              <span v-html="resIndice"></span>
            </div> -->
            <b-modal id="modal-xl-ideacion" size="xl" :title="funciones" hide-footer>
                <div class="accordion" role="tablist" id="accordionIdeacion">
                    <b-card v-for="(item, index) in resIndice2" v-bind:key="index" no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-button block v-b-toggle="`collapse-${ index }-ideacion`" variant="info">{{ item.title }}</b-button>
                        </b-card-header>
                        <b-collapse :id="`collapse-${ index }-ideacion`" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text v-html="item.paper_index"></b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "TabIdeacion",
    data() {
        return {
            resIndice: null,
            resIndice2: [{'title':'','paper_index':''}],
            patron: null,
            anio: 0,
            funciones: null,
            optionsTipoAnio: [
                { value: "null", label: "-" },
                { value: "2007", label: "2007" },
                { value: "2008", label: "2008" },
                { value: "2009", label: "2009" },
                { value: "2010", label: "2010" },
                { value: "2011", label: "2011" },
                { value: "2012", label: "2012" },
                { value: "2013", label: "2013" },
                { value: "2014", label: "2014" },
                { value: "2015", label: "2015" },
                { value: "2016", label: "2016" },
                { value: "2017", label: "2017" },
                { value: "2018", label: "2018" },
                { value: "2019", label: "2019" },
                { value: "2020", label: "2020" },
                { value: "2021", label: "2021" },

            ],
            optionsFunciones:[
                {value: 'Títulos', label:"Títulos"},
                {value: 'Palabras clave', label:"Palabras clave"},
                {value: 'Nubes conceptuales', label:"Nubes conceptuales"},
                {value: 'Hallazgos previos', label:"Hallazgos previos"},
                {value: 'Espacios de contribución', label:"Espacios de contribución"},
                {value: 'Relevancia investigaciones previas', label:"Relevancia investigaciones previas"}

            ],
        };
    },
    methods: {
        async submitHandler() {
            let loader = this.$loading.show({ isFullPage: true, canCancel: false });
            try {
                const formData = new FormData();
                formData.append("patron", this.patron);
                formData.append("anio", this.anio);
                formData.append("funciones", this.funciones);
                let res = await axios.post(
                    "http://www.redilegra.com/backend/api/Ideacion",
                    //"http://127.0.0.1:8000/api/Concordancia",
                    formData
                );
                this.resIndice = res.data.html_response;
                this.resIndice2 = res.data.context2;
                this.makeToast(
                    "Mostrar Indice realizado exitosamente.",
                    "success"
                );
            } catch (err) {
                console.warn(err);
                this.makeToast(err, "danger");
            }
            loader.hide();
        },
        makeToast(message, variant) {
            let title =
                variant == "success" ? "Operación exitosa" : "Operación fallida";
            this.$bvToast.toast(message, {
                title: title,
                variant: variant,
                solid: false,
                autoHideDelay: 2000,
            });
        },
    },
};
</script>